import { Registry } from './registry';

/** Fetches /content-pack.json (served by the Vite plugin in dev, emitted at build). */
export async function loadRegistryBrowser(origin = ''): Promise<Registry> {
  const base = (import.meta.env.BASE_URL || '/').replace(/\/$/, '');
  const res = await fetch(`${origin}${base}/content-pack.json`);
  if (!res.ok) throw new Error(`content pack: HTTP ${res.status}`);
  const pack = (await res.json()) as Record<string, unknown>;
  const reg = new Registry();
  for (const [path, data] of Object.entries(pack)) reg.addRaw(path, data);
  return reg;
}
